//
//
//
//
//
//

export default {
	data() {
		return {
			dataX: [],
			dataY: []
		};
	},
	watch: {
		yData() {
			this.drawLine();
		}
	},
	props: ["id", "xData", 'yData'],
	mounted() {
		setTimeout(() => {
			this.drawLine();

		}, 2000);
	},
	methods: {
		fontSize(res) {
			let docEl = document.documentElement,
				clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			if (!clientWidth) return;
			let fontSize = 100 * (clientWidth / 1920);

			return res * fontSize;
		},
		drawLine() {
			let myChart = this.$echarts.init(document.getElementById(this.id));
			myChart.setOption({
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross',
						crossStyle: {
							color: '#999'
						}
					}
				},
				grid: {
					top: '12%',
					left: '5%',
					right: '10%',
					bottom: '20%',
					containLabel: true
				},
				legend: {
					data: ['办件数'],
					y: '84%',
					x: 'center',
					textStyle: { //图例文字的样式
						color: 'rgba(165,195,252,1)',
						// fontSize:'0.48rem'
						fontSize: this.fontSize(0.12)
					},
				},
				xAxis: [{
					type: 'category',
					name: '窗口',
					nameTextStyle: {
						color: "rgba(102,152,255,1)",
						// fontSize:'0.36rem',
						fontSize: this.fontSize(0.1),
						padding: 0
					},
					data: this.xData.filter(d => d),
					// data: ['01','02','03','04','05','06','07','08','09','10','11','12'],
					axisPointer: {
						type: 'shadow'
					},

					axisLabel: {
						formatter: '{value}',
						textStyle: { //改变刻度字体样式
							fontWeight: '400',
							color: 'rgba(102,152,255,1)',
							fontSize: this.fontSize(0.1),
							// fontSize:'0.36rem',
							fontFamily: 'Alibaba PuHuiTi'
						}
					},
					axisLine: {
						lineStyle: {
							color: '#4D30F0'
						}
					},
					splitLine: {
						show: false //网格线不显示
					},
					/////////////不显示刻度
					axisTick: {
						show: false
					},

				}],
				yAxis: [{
					type: 'value',
					name: '件数',
					nameTextStyle: {
						color: "rgba(102,152,255,1)",
						fontSize: this.fontSize(0.1),
						// fontSize:'0.36rem',
						padding: 0
					},
					/////////////不显示刻度
					axisTick: {
						show: false
					},
					splitLine: {
						show: false //网格线不显示
					},
					axisLabel: {
						formatter: '{value} ml'
					},
					minInterval: 1,
					axisLine: {
						lineStyle: {
							color: '#4D30F0'
						}
					},
					axisLabel: {
						formatter: '{value}',
						textStyle: { //改变刻度字体样式
							fontWeight: '400',
							color: 'rgba(102,152,255,1)',
							fontSize: this.fontSize(0.1),
							// fontSize:'0.36rem',
							fontFamily: 'Alibaba PuHuiTi'
						}
					}
				}],
				series: [{
					name: '办件数',
					type: 'bar',
					barWidth: this.fontSize(0.2),
					data: this.yData,
					// data:[22, 32, 12, 34, 32, 32, 54,12,12,34, 43,20],
					itemStyle: {
						normal: {
							color: new this.$echarts.graphic.LinearGradient(
								0, 0, 0, 1,
								[{
										offset: 0,
										color: 'rgba(250,34,167,1)'
									},
									{
										offset: 1,
										color: 'rgba(173,30,255,1)'
									},
									// {offset: 0, color:'rgba(16,231,255,1)'},
									//    {offset: 1, color: 'rgba(26,116,251,1)'},                   //柱图渐变色
									//				                        {offset: 0.5, color: '#44C0C1'},                 //柱图渐变色
									//柱图渐变色
								]
							)
						},
					}
				}]
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/d_zhuxingTwo.vue